import { TraceLevel } from "@ms/uno-telemetry/lib/local/events/Trace.event";
export function logUnreachableAction(store, loggers, action) {
    loggers.traceLogger.logTrace(0x1e3dd0c6 /* tag_4p3dg */ , TraceLevel.Warning, `Unexpected action encountered: [ActionType=${action.type}][Store=${store.name}]`);
}
